import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-61f40e73")

_pushScopeId("data-v-61f40e73")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12-sm col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", { class: "ls-slate" }, "Signing Out...", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")
  const _component_StdPageLayout = _resolveComponent("StdPageLayout")

  return (_openBlock(), _createBlock(_component_StdPageLayout, null, {
    "body-content": _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_LoadingSpinner)
          ])
        ])
      ])
    ]),
    _: 1
  }))
})